import { render, staticRenderFns } from "./StreamerProfile.vue?vue&type=template&id=f427f09a&"
import script from "./StreamerProfile.vue?vue&type=script&lang=js&"
export * from "./StreamerProfile.vue?vue&type=script&lang=js&"
import style0 from "./StreamerProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports